module.exports = __webpack_public_path__ + "static/media/close.487cf3ba.svg";